<template>
  <NTabs
    :model-value="selectedTab"
    class="w-full min-w-[21.5rem] mb-1"
    @update:model-value="updateTab"
  >
    <NTab :title="FREEZE_UNFREEZE_TABS.freeze.label">
      <FreezeUnfreezeForm :is-freeze="true" />
    </NTab>

    <NTab :title="FREEZE_UNFREEZE_TABS.unfreeze.label">
      <FreezeUnfreezeForm :is-freeze="false" />
    </NTab>
  </NTabs>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import { FREEZE_UNFREEZE_TABS } from '@/modules/option';

import FreezeUnfreezeForm from './FreezeUnfreezeForm.vue';

type TFreezeUnfreezeDialogProps = {
  isFreeze: boolean;
};

defineProps<TFreezeUnfreezeDialogProps>();

const emit = defineEmits<{
  (e: 'update:isFreeze', value: boolean): void;
}>();

const selectedTab = ref(FREEZE_UNFREEZE_TABS.freeze.value);

const updateTab = (val) => {
  selectedTab.value = val;

  emit('update:isFreeze', val === FREEZE_UNFREEZE_TABS.freeze.value);
};
</script>
